import image from "@/assets/holiday-cards/holiday-card-media-recommendations.png";
import { DayDefinition } from "../DayDefinition.js";
import RandomButton from "../shared/RandomButton.js";

/** Class Media_Recommendations Represents the Media Recommendations card. */
export class Media_Recommendations extends DayDefinition {
	/** The CSS class to use for the card. */
	public className = "hl:bg-darkbrown2022";
	public image = image;
	/** The slug for the card. Used to identify the card for css, etc. */
	public slug = "media-recommendations";

	/** Get the display for the card in English. */
	public initENCard(): void {
		this.title = "Rootree's Recommended Reading &amp; Watching List";
		this.content = (
			<>
				<p className="hl:whitespace-pre-line">
					{`Let’s face it, Home Alone is a classic.
					But there are only so many times it can be re-run.
					Whether you’re wanting to have a Netflix binge.
					Or enjoy a night in with a loved one.
					Our staff has shared a list of their faves,
					Books & movies you can enjoy this holiday season.
					Turns out that sustainable flexible packaging
					Is not the only thing they have expertise in.`}
				</p>
				<RandomButton
					buttonTheme="foliage"
					content={books_en}
					title="Get a book"
				/>
				<RandomButton
					buttonTheme="foliage"
					content={movies_en}
					title="Get a movie"
				/>
				<RandomButton
					buttonTheme="foliage"
					content={series_en}
					title="Get a TV show"
				/>
			</>
		);
	}

	/** Get the display for the card in French. */
	public initFRCard(): void {
		this.title =
			"Les lectures, films et séries TV chaudement recommandés par Rootree cet hiver.";
		this.content = (
			<>
				<p className="hl:whitespace-pre-line">
					{`Voyons les choses en face : "Maman j'ai raté l'avion" est un classique
					Mais il ne peut être vu qu'un nombre limité de fois
					Que vous ayez envie d'une soirée Netflix
					Ou d'une soirée aux côtés d'un être cher
					Notre équipe vous partage la liste de ses livres et films favoris
					Pour un bon moment de détente pendant les fêtes.
					Comme quoi, l'emballage flexible et durable
					N'est pas le seul domaine dans lequel ils sont experts.`}
				</p>
				<RandomButton
					buttonTheme="foliage"
					content={books_fr}
					title="Envie d'un livre ?"
				/>
				<RandomButton
					buttonTheme="foliage"
					content={movies_fr}
					title="Envie d'un film ?"
				/>
				<RandomButton
					buttonTheme="foliage"
					content={series_fr}
					title="Envie d'une série TV ?"
				/>
			</>
		);
	}
}

/** Books in English */
const books_en = [
	"Outlander (series) – Diana Gabaldon",
	"Clan of the Cave Bear – Jean M Auel",
	"Neverwhere - Neil Gaiman",
	"Pride & Prejudice -Jane Austen",
	"Harry Potter - JK Rowling",
	"A Christmas Carol - Charles Dickens",
	"Bringing down the house – Ben Mezrich",
	"Ready Player One #1 – Ernest Cline",
	"Art of Peace – Morihei Ueshiba",
	"No One Wins Alone – Mark Messier",
	"If Chins Could Kill: Confessions of a B movie actor – Bruce Campbell",
	"And The Mountains Echoed - Khalid Hussein",
	"A Thousand Splendid Suns - Khalid Hussein",
	"Stay with me - Ayobami Adebayo",
	"Never Grow up – Jackie Chan",
	"The Life, Lessons & Rules for Success – Dwayne “The Rock” Johnson",
	"The Alchemist – Paolo Coehlo",
	"Le Petit Prince – Antoine de Saint - Exupery",
	"The Secret – Rhonda Byrne",
	"Power of Now – Eckhart Tolle",
	"How to Win Friends & Influence People – Dale Carnegie",
	"The Prophet – Khalil Gibran",
	"The Elf on the Shelf – Carol Aebersold",
	"Once Upon a North Pole Christmas – Diana & Noel Manning",
];

/** Books in French */
const books_fr = [
	"Outlander (14 tomes) - Diana Gabaldon",
	"Le Clan de l'Ours des Cavernes - Jean M. Auel",
	"Neverwhere - Neil Gaiman",
	"Orgueil et préjugés - Jane Austen",
	"Harry Potter - JK Rowling",
	"Un chant de Noël - Charles Dickens",
	"Bringing Down The House - Ben Mezrich",
	"Ready Player One #1 - Ernest Cline",
	"The Art of Peace - Morihei Ueshiba",
	"No One Wins Alone - Mark Messier",
	"If Chins Could Kill: Confessions of a B Movie Actor - Bruce Campbell",
	"Ainsi résonne l'écho infini des montagnes - Khalid Hussein",
	"Mille Soleils Splendides - Khalid Hussein",
	"Stay With Me -Ayobami Adebayo",
	"Ne jamais grandir - Jackie Chan",
	"The Life, Lessons & Rules for Success – Dwayne “The Rock” Johnson L'Alchimiste - Paolo Coehlo",
	"Le Petit Prince - Antoine de Saint-Exupéry",
	"Le Secret - Rhonda Byrne",
	"Le Pouvoir du moment présent - Eckhart Tolle",
	"Comment se faire des amis - Dale Carnegie",
	"Le Prophète - Khalil Gibran",
	"The Elf on the Shelf – Carol Aebersold",
	"Once Upon a North Pole Christmas – Diana & Noel Manning",
];

/** Movies in English */
const movies_en = [
	"Elf",
	"Home Alone",
	"Christmas Chronicles",
	"Grinch",
	"It’s a Wonderful Life",
	"A Muppet Christmas Carol",
	"The Nightmare Before Christmas",
	"A Christmas Story",
	"National Lampoon's Christmas Vacation",
	"Holiday",
	"Scrooged",
	"Love Actually",
	"It’s a Wonderful Life",
	"Polar Express",
	"Encanto",
	"Moana",
	"Cloud Atlas",
	"Pirates of the Carribean",
	"Rumble in the Bronx",
	"Rush Hour Series",
	"Drunken Master Series",
	"Marvel",
	"Star Wars",
	"10th Kingdom",
	"Pride and Prejudice",
	"Dirty Dancing",
	"She's the Man",
	"Mamma Mia",
	"Braveheart",
	"Zoolander",
	"Christopher Nolan Batman trilogy",
	"Goodfellas",
	"Fight Club",
	"Gremlins",
	"Blind Side",
	"Maheshinte Prathikaaram – Malayalam Movie",
	"Home – Malayam Movie",
	"Sound of Music",
	"Harry Potter",
	"Lord of the Rings",
	"Iron Man",
	"Captain America",
	"Black Panther",
	"Avengers",
	"Die Hard",
	"Black Adder Christmas Carol",
	"Fast and Furious Collection",
	"Oceans 11",
	"IP Man Series",
	"Shang - Chi",
	"Luca",
	"The Count of Monte Cristo",
	"Les Intouchables",
	"Dear John",
	"Burlesque",
	"Romeo and Juliet",
	"Sing",
	"The Family Man",
];

/** Movies in French */
const movies_fr = [
	"Elfe",
	"Maman, j'ai raté l'avion !",
	"Les Chroniques de Noël",
	"Le Grinch",
	"La vie est belle",
	"Noël chez les Muppets",
	"L'Étrange Noël de monsieur Jack",
	"A Christmas Story",
	"Le sapin a les boules",
	"The Holiday",
	"Fantômes en fête",
	"Love Actually",
	"Le Pôle Express",
	"Encanto",
	"Moana",
	"Cloud Atlas",
	"Pirates des Caraïbes",
	"Jackie Chan dans le Bronx",
	"Rush Hour",
	"Le Maître chinois",
	"Marvel",
	"Star Wars",
	"Le Dixième Royaume",
	"Orgueil et Préjugés",
	"Dirty Dancing",
	"She's the Man",
	"Mamma Mia",
	"Braveheart",
	"Zoolander",
	"La trilogie Batman de Christopher Nolan",
	"Les Affranchis",
	"Fight Club[Text Wrapping Break]Gremlins",
	"The Blind Side",
	"Maheshinte Prathikaaram (Malayalam)",
	"Home (Malayam)",
	"La Mélodie du Bonheur",
	"Harry Potter",
	"Le Seigneur des Anneaux",
	"Iron Man",
	"Captain America",
	"Black Panther",
	"Shang-Chi",
	"Avengers",
	"Die Hard",
	"La Vipère noire : Un conte de Noël",
	"Fast and Furious",
	"Ocean's Eleven",
	"IP Man",
	"Luca",
	"Le Comte de Monte Cristo",
	"Les Intouchables",
	"Cher John",
	"Burlesque",
	"Roméo + Juliette",
	"Tous en scène",
	"Family Man",
];

/** TV Series in English */
const series_en = [
	"Schitt’s Creek",
	"Netflix's Daredevil",
	"Last Kingdom",
	"Suits",
	"Mentalist",
	"Stranger Things",
	"The Mandalorian",
	"Brooklyn 99",
	"Emily in Paris",
	"Queen’s Gambit",
	"Chef’s Table",
	"Black Spot",
	"Rick and Morty",
	"Virgin River",
	"The wire",
	"Game of Thrones",
	"Dexter",
	"Breaking Bad",
	"Big Bang Theory",
	"Blacklist",
	"Criminal Minds(SVU & BAU)",
	"The Raid series",
	"Lupin",
	"Friends",
	"Arrow",
];

/** TV Series in French */
const series_fr = [
	"Bienvenue à Schitt's Creek",
	"Daredevil",
	"The Last Kingdom",
	"Suits : Avocats sur mesure",
	"Mentalist",
	"Stranger Things",
	"The Mandalorian",
	"Brooklyn 99",
	"Emily in Paris",
	"Le Jeu de la dame",
	"Chef's Table",
	"Zone Blanche",
	"Rick and Morty",
	"Virgin River",
	"The Wire",
	"Game of Thrones",
	"Dexter",
	"Breaking Bad",
	"Big Bang Theory",
	"Blacklist",
	"Esprits criminels (SVU & BAU)",
	"The Raid",
	"Lupin",
	"Friends",
	"Arrow",
];
